import { render } from "./VerifyCode.vue?vue&type=template&id=f7f4f096&scoped=true"
import script from "./VerifyCode.vue?vue&type=script&lang=js"
export * from "./VerifyCode.vue?vue&type=script&lang=js"

import "./VerifyCode.vue?vue&type=style&index=0&id=f7f4f096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f4f096"]])

export default __exports__